import classNames from 'classnames'
import { useMemo } from 'react'

import { UnitTaskStatus } from '@apps-common/config/unit-task'

interface IProps {
  status: string
}

export const TaskStatusWidget: React.FC<IProps> = ({ status }) => {
  const classes = useMemo(() => {
    switch (status) {
      case UnitTaskStatus.pending:
        return 'bg-info/50 text-on-info ring-1 ring-info'

      case UnitTaskStatus.processing:
        return 'bg-info/50 text-on-info ring-1 ring-info'

      case UnitTaskStatus.awaitingRetry:
        return 'bg-info/50 text-on-info ring-1 ring-info'

      case UnitTaskStatus.success:
        return 'bg-success/50 text-on-success ring-1 ring-success'

      case UnitTaskStatus.failed:
        return 'bg-error/50 text-on-error ring-1 ring-error'

      case UnitTaskStatus.cancelled:
        return 'bg-warning/50 text-on-warning ring-1 ring-warning'

      default:
        return 'bg-border/50 text-text-muted ring-1 ring-border'
    }
  }, [status])

  const transformedStatus = useMemo(() => status?.toLowerCase()?.replaceAll('_', ' ')?.trim() || 'unknown', [status])

  return (
    <div className='flex items-center justify-start min-w-[100px]'>
      <div className={classNames(classes, 'capitalize text-[0.8rem] px-2 py-[2px] rounded-full min-w-[74px] text-center')}>
        {transformedStatus}
      </div>
    </div>
  )
}
